<biosimulations-error icon="maintainence" [pageHasBreadCrumbs]="pageHasBreadCrumbs">
  <ng-container id="message">Under maintainence</ng-container>
  <ng-container id="details"> Sorry, we're down for maintainence. We'll be back soon! </ng-container>
</biosimulations-error>
